import { useState } from 'react';
import './hero.css';
import { useNavigate } from "react-router-dom";
import { API_URL } from '../../config/api';

function Hero() {
  const [form, setForm] = useState({ name: '', email: '' });
  const [status, setStatus] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');
    try {
      const response = await fetch(`${API_URL}/subscribe/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      if (data.success) {
        setStatus("🎉 You're in! Talk soon.");
        setForm({ name: '', email: '' });
        setSubmitted(true);
      } else {
        setStatus('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setStatus('Error connecting to server.');
    }
  };

  return (
    <section className="hero">

      {/* Intro */}
      <div className="hero-intro">
        <h1 className="hero-title">
          Hello, I'm{' '}
          <span className="hero-wavy">
            Loubna
            <svg className="wavy-svg" viewBox="0 0 160 12" preserveAspectRatio="none">
              <path d="M0,6 C20,0 40,12 60,6 C80,0 100,12 120,6 C140,0 160,12 160,6" fill="none" stroke="var(--purple-accent)" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
          </span>{' '}
          👋
        </h1>
        <p className="hero-subtitle">
          Software Engineer &amp; Published Author passionate about
          optimization, Machine Learning, coding, and storytelling.
        </p>
        <div className="hero-buttons">
          <button onClick={() => navigate('/my-books')} className="hero-btn">
            Explore My Books
          </button>
          <button onClick={() => navigate('/tech-projects')} className="hero-btn secondary">
            View Tech Projects
          </button>
        </div>
      </div>

      {/* Subscribe card */}
      <div className="hero-subscribe-card">
        <h2 className="subscribe-title">
          Subscribe to{' '}
          <span className="subscribe-accent">my Writing Notes</span>
          ✍️
        </h2>
        <div className="subscribe-body">
          <div className="subscribe-copy">
            <p>
              Occasional notes on writing, creativity, books,
              and life — no spam, just stories and inspiration.
            </p>
            <p>
              Join me on this journey as I explore the world of
              storytelling and share what I learn along the way. 📚
            </p>
          </div>
          <div className="subscribe-form">
            {!submitted ? (
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  className="subscribe-input"
                  placeholder="Your name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  className="subscribe-input"
                  placeholder="Your email address"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
                <button type="submit" className="subscribe-btn">
                  {status === 'Sending...' ? 'Sending...' : 'Subscribe'}
                </button>
                {status && !submitted && (
                  <p className="subscribe-error">{status}</p>
                )}
                <p className="subscribe-note">Unsubscribe anytime. Your inbox is safe with me. 🌷</p>
              </form>
            ) : (
              <p className="subscribe-success">{status}</p>
            )}
          </div>
        </div>
      </div>

    </section>
  );
}

export default Hero;